<template>
  <div class="select-date-picker">
    <div class="el-input-group--append el-input-group--prepend">
      <div class="el-input-group__prepend">
        <el-select v-model="selectType" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <el-date-picker
      v-model="dateValue"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
      :picker-options="startDatetions"
      @change="handleChange"
    >
    </el-date-picker>
  </div>
</template>

<script>
// 根据key 在对象中取值
const getDatePickerValue = (valueObj, dateProps) => {
  let beginTime = '';
  let endTime = '';
  if (valueObj) {
    beginTime = valueObj[dateProps.beginTime];
    endTime = valueObj[dateProps.endTime];
  }
  return {
    beginTime,
    endTime,
  };
};

export default {
  props: {
    options: {
      type: Array,
      default: () => ([]),
    },
    // 参数
    date: {
      type: [Object, String],
      required: true,
      default: () => ({
        beginTime: '',
        endTime: '',
      }),
    },
    // 其他参数项
    dateProps: {
      type: Object,
      default: () => ({
        beginTime: 'beginTime',
        endTime: 'endTime',
      }),
    },
    // 组件参数项
    query: {
      type: Object,
    },
    type: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      dateValue: [],
      startDatetions: {
        disabledDate: (time) => {
          return time.getTime() > new Date();
        },
      },
    };
  },
  computed: {
    selectType: {
      get() {
        return this.type;
      },
      set(val) {
        this.$emit('update:type', val);
      },
    },
  },
  watch: {
    // 空值
    date: {
      deep: true,
      immediate: true,
      handler(val) {
        const { beginTime, endTime } = getDatePickerValue(val, this.dateProps);
        if (!beginTime) {
          this.dateValue = [];
        }
        if (beginTime && endTime) {
          this.dateValue = [beginTime, endTime];
        }
      },
    },
  },
  methods: {
    handleChange() {
      // 其他参数返回值设定
      const { beginTime, endTime } = this.dateProps;
      this.$emit('setFormFields', {
        [beginTime]: this.dateValue ? this.dateValue[0] : '',
        [endTime]: this.dateValue ? this.dateValue[1] : '',
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-input-group__prepend {
    .el-select {
      .el-input {
        width: 120px;
      }
    }
  }
  .el-range-editor--small.el-input__inner {
    height: 34px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .el-date-editor {
    width: 280px !important;
  }
}

.select-date-picker {
  display: flex;
  align-items: center;
}
</style>
